import * as React from 'react';

import { ReportCard } from '../ReportCard';
import { ReportExampleInfo, IReportExampleInfoProps } from '../ReportExampleInfo';

import * as styles from './styles.css';

export type IReportExampleBlockProps = IReportExampleInfoProps;

export const ReportExampleBlock: React.FC<IReportExampleBlockProps> = props => {
  return (
    <div className={styles['container']}>
      <div className={styles['left']}>
        <div className={styles['report_positioner']}>
          <div className={styles['report_container']}>
            <ReportCard />
          </div>
        </div>
      </div>
      <div className={styles['description']}>
        <ReportExampleInfo {...props} />
      </div>
    </div>
  );
};

ReportExampleBlock.displayName = 'ReportExampleBlock';
